import { render, staticRenderFns } from "./UsersDetails.vue?vue&type=template&id=6e132458&"
import script from "./UsersDetails.vue?vue&type=script&lang=js&"
export * from "./UsersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports